<template>
  <div class="header">
    <router-link to="/">
      <h1>Unplugged</h1>
    </router-link>
    <h3>Hey, I just wanted to write!</h3>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {},
};
</script>

<style scoped>
.header h1 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 88px;
  color: #6cff91;
  letter-spacing: -3px;
  font-family: monospace;
  font-weight: bolder;
  text-decoration: none;
}
.header h3 {
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 20px;
  font-size: 14px;
  color: #a6eaff;
}
.header a:hover {
  text-decoration: none;
}
</style>
